<template>
    <div>
        <h4 class="mb-2">
            <span class="text-muted">Prospetto Rate e Importi</span>
        </h4>
        <div class="bg-white border rounded small" v-if="form && form.aa && form.installments">
            <div>
                <!-- Primo Anno -->
                <div class="p-4" v-if="form.installments && form.prospect && form.prospect_next && form.prospect.program && form.prospect_next.program">
                    <p><strong>PROSPETTO RATE E IMPORTI 1° ANNO</strong></p>
                    <table class="table table-sm table-bordered text-secondary mb-0 table-rate">
                        <thead>
                            <tr class="border-bottom">
                                <th class="bg-light">Modalità</th>
                                <th class="text-center bg-light">Importo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="border-bottom"> 
                                <td>
                                    <span v-if="form.installments.label == 12">Da versare ogni ultimo giorno del mese</span>
                                    <span v-else-if="form.installments.label == 4">Pagamento in 4 rate</span>
                                    <span v-else>Pagamento in unico importo</span>
                                </td> 
                                <td class="text-center" v-if="form.prospect && form.prospect.program">
                                    <strong>€ {{ $formattaNumeroItaliano(form.prospect.program.import / form.installments.label) }}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="1" class="bg-light"><strong>Totale</strong></td>
                                <td class="bg-light text-center"><strong>€ {{ $formattaNumeroItaliano(form.prospect.program.import) }}</strong></td>
                            </tr>
                        </tbody>
                    </table>
                    <span class="mt-2 d-block small text-muted" v-if="form.prospect && form.prospect.program">
                        Ad ogni rata va aggiunto il Contributo per i Servizi agli Studenti di 
                        <strong>€ {{ $formattaNumeroItaliano(form.prospect.program.tax / form.installments.label) }}</strong>
                    </span>
                    <span v-if="form.convention && form.convention.label.includes('MULTIVERSITY CARD')" class="mt-0 d-block small text-muted">
                        Alla prima rata si aggiungono <strong>€ 50</strong> per la Multiversity Card
                    </span>
                </div>
                <div class="px-4 pb-4">
                    <p><strong>PROSPETTO RATE E IMPORTI ANNI SUCCESSIVI</strong></p>
                    <table class="table table-sm table-bordered text-secondary mb-0 table-rate">
                        <thead>
                            <tr class="border-bottom">
                                <th class="bg-light">Modalità</th>
                                <th class="text-center bg-light">Importo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="border-bottom"> 
                                <td>
                                    <span v-if="form.installments.label == 12">Da versare ogni ultimo giorno del mese</span>
                                    <span v-else-if="form.installments.label == 4">Pagamento in 4 rate</span>
                                    <span v-else>Pagamento in unico importo</span>
                                </td> 
                                <td class="text-center" v-if="form.prospect_next && form.prospect_next.program">
                                    <strong>€ {{ $formattaNumeroItaliano(form.prospect_next.program.import / form.installments.label) }}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="1" class="bg-light"><strong>Totale</strong></td>
                                <td class="bg-light text-center" v-if="form.prospect_next && form.prospect_next.program">
                                    <strong>€ {{ $formattaNumeroItaliano(form.prospect_next.program.import) }}</strong>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <span class="mt-2 d-block small text-muted" v-if="form.prospect_next && form.prospect_next.program">
                        Ad ogni rata va aggiunto il Contributo per i Servizi per gli Studenti di 
                        <strong>€ {{ $formattaNumeroItaliano(form.prospect_next.program.tax / form.installments.label) }}</strong>
                    </span>
                    <span v-if="form.convention && form.convention.label.includes('MULTIVERSITY CARD')" class="mt-0 d-block small text-muted">
                        Alla prima rata si aggiungono <strong>€ 50</strong> per la Multiversity Card
                    </span>
                </div>
            </div>
        </div>
    </div> 
</template>

<script>
    export default {
        computed: {
            form() {
                return this.$store.getters['summary/form']
            },
            recap () {
                return this.$store.getters['summary/recap']
            },
            program() {
                return this.$store.getters['summary/program']
            },
            rate() {
                return this.$store.getters['summary/rate']
            },
            label () {
                return this.$store.getters['summary/label'] ?? 'NOLABEL'
            },
            years () {
                const course = this.$store.getters['summary/course']
                return course.duration - 1
            },
        }
    }
</script>

<style>

</style>